import {categoriesTree} from "@/static/categories-tree";
import {API_URL_CATALOG} from "./urls";

// GET requests

const getCategoriesApi = () => {
  return window.axios

    .get(API_URL_CATALOG + "product/category/all/v1/get")

    .then(({ data }) => {
      if (data.code === "OC_OK") {
        const categories = data.createdEntity.listOfProductCategory.map(
          (category) => {
            const categorySubCategories = categoriesTree[category.code];
            return {
              ...category,
              subCategories: category.productCategoryChildList.filter(
                (subCategory) => {
                  return categorySubCategories?.includes(subCategory.code);
                }
              ),
            };
          }
        );

        return categories.map((category) => {
          return {
            ...category,
            subCategories: category.subCategories.map((category) => {
              return {
                ...category,
                abstractProductList: category.abstractProducts.map(
                  (product) => {
                    return {
                      ...product,
                      name: product.abstractProductShortName,
                      code: product.abstractProductCode,
                    };
                  }
                ),
              };
            }),
          };
        });
      }

      throw new Error(data.message);
    })

    .catch((error) => {
      throw error;
    });
};

export { getCategoriesApi };
